import { sendTelemetryEvent } from '@fluidx/telemetry';
import { GenericEvent } from '../telemetry/GenericEvent';
export async function configureMandatoryLabeling(container, informationProtectionService, resolvedUrl, mipCache, tracker, logger) {
    tracker?.markSubActivityStart('ConfigureMandatoryLabeling');
    let mandatoryEnforcedReadOnly = false;
    const mandatoryLabelHandler = () => {
        // FF does not currently support setting readonly on dirty containers
        queueForceReadOnly();
    };
    // Workaround for FF Issue: https://github.com/microsoft/FluidFramework/issues/10191
    const queueForceReadOnly = () => {
        if (!container.isDirty) {
            queueMicrotask(() => {
                // checks for clean container one more time before setting it dirty
                if (!container.isDirty) {
                    container.forceReadonly?.(true);
                    mandatoryEnforcedReadOnly = true;
                    logger && sendTelemetryEvent(logger, { eventName: GenericEvent.MandatoryLabelHandlerSetReadOnly });
                }
                else {
                    queueForceReadOnly();
                }
            });
        }
        else {
            container.once('saved', queueForceReadOnly);
        }
    };
    const labelChangedHandler = () => {
        if (mandatoryEnforcedReadOnly) {
            container.forceReadonly?.(false);
            logger && sendTelemetryEvent(logger, { eventName: GenericEvent.MandatoryLabelHandlerResetReadOnly });
        }
    };
    const getIsMandatory = async () => {
        const [currentLabel, policySettings] = await Promise.all([
            informationProtectionService.getCurrentLabel(resolvedUrl),
            informationProtectionService.getPolicySettings()
        ]);
        if (policySettings?.isMandatory && !currentLabel) {
            mandatoryLabelHandler();
        }
    };
    informationProtectionService.on('sensitivityLabelChanged', labelChangedHandler);
    if (mipCache?.policySettings) {
        if (mipCache.policySettings.isMandatory && !mipCache.currentLabel) {
            mandatoryLabelHandler();
        }
        getIsMandatory().catch(() => { });
    }
    else {
        await getIsMandatory();
    }
    tracker?.markSubActivityEnd('ConfigureMandatoryLabeling');
}
//# sourceMappingURL=configureMandatoryLabeling.js.map